import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';

const COLORS = ['#f7c948', '#0f172a', '#e09f15', '#10b981', '#94a3b8', '#fde68a'];

interface Piece {
  id: number;
  x: number;
  y: number;
  rotate: number;
  color: string;
  size: number;
  round: boolean;
}

function makePieces(n: number): Piece[] {
  return Array.from({ length: n }, (_, id) => {
    const angle = Math.random() * Math.PI * 2;
    const dist = 140 + Math.random() * 260;
    return {
      id,
      x: Math.cos(angle) * dist,
      y: Math.sin(angle) * dist - 120,
      rotate: Math.random() * 720 - 360,
      color: COLORS[id % COLORS.length]!,
      size: 6 + Math.random() * 8,
      round: Math.random() > 0.5,
    };
  });
}

/** One-shot confetti burst from the centre of the screen while `show` is true. */
export function Celebrate({ show }: { show: boolean }) {
  // New random pieces for every burst.
  const pieces = React.useMemo(() => (show ? makePieces(60) : []), [show]);
  return (
    <AnimatePresence>
      {show && (
        <div aria-hidden className="pointer-events-none fixed inset-0 z-[60] flex items-center justify-center overflow-hidden">
          {pieces.map((p) => (
            <motion.span
              key={p.id}
              className="absolute"
              style={{ width: p.size, height: p.round ? p.size : p.size * 0.45, background: p.color, borderRadius: p.round ? 999 : 2 }}
              initial={{ x: 0, y: 0, opacity: 1, rotate: 0, scale: 0.4 }}
              animate={{ x: p.x, y: [0, p.y, p.y + 420], opacity: [1, 1, 0], rotate: p.rotate, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 2.2, ease: [0.2, 0.8, 0.4, 1], times: [0, 0.4, 1] }}
            />
          ))}
        </div>
      )}
    </AnimatePresence>
  );
}
